<div class="ziti-page-container lt-skin-page">
    <lib-list-table-header
        title="OIDC Issuers"
        subtitle="The OIDC issuers this organization trusts to sign in users"
        createLabel="Create OIDC Issuer"
        infoText="An OIDC issuer is an identity provider whose tokens this organization accepts to sign in users."
        [tabs]="tabs"
        [showAdd]="!hasSelection"
        [blockCreate]="createBlocked"
        [blockDelete]="!isDeleteAction || createVisibility.isCancelledAccount"
        (actionClicked)="onHeaderAction($event)"
    >
        <span header-icon class="icon-CAs" aria-hidden="true"></span>
    </lib-list-table-header>

    <div class="oidc-issuers-panel-row" [class.is-split]="!!selected">
        <div class="oidc-issuers-list-panel">
            <lib-list-table
                class="lt-skin"
                [tableId]="tableId"
                [initialPageSize]="initialPageSize"
                [options]="tableOptions"
                [columns]="columns"
                [rowData]="displayed"
                [isLoading]="isLoading"
                [hasNext]="hasNext"
                [hasPrev]="hasPrev"
                [startCount]="startCount"
                [endCount]="endCount"
                [totalCount]="filteredCount"
                [filterApplied]="listFilterApplied"
                [filterColumn]="searchFilter"
                [menuItems]="menuItems"
                [accessDenied]="accessDenied"
                filterName="Issuer"
                entityTypeName="OIDC issuers"
                noItemsImage="nodata"
                [showNoItemsAdd]="!createBlocked"
                [noItemsReadonly]="createBlocked"
                (selectionChanged)="onSelectionChanged($event)"
                (actionRequested)="onAction($event)"
            ></lib-list-table>
        </div>

        @if (selected; as issuer) {
        <app-detail-drawer
            eyebrow="OIDC Issuer Detail"
            [title]="issuer.issuer"
            [index]="selectedIndex"
            [total]="displayed.length"
            (closed)="closeDetail()"
            (navigated)="navigateDetail($event)"
        >
            <app-record-detail
                [sections]="detailSections(issuer)"
                [actions]="detailActions(issuer)"
                (action)="onAction({ action: $event, item: issuer })"
            ></app-record-detail>
        </app-detail-drawer>
        }
    </div>
</div>
